module.exports = "<section class=\"mat-typography cao-content\">\n  database works!\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/src/app/database/database.component.html
// module id = ../../../../../src/app/database/database.component.html
// module chunks = main